/* -------------------------------------------------------------------------- */
/* --------------------------- THEME : FRAMEWORKS --------------------------- */

// FRAMEWORKS : NODES_MODULES
import gsap from "gsap";
import "gsap/EasePack";
import ScrollTrigger from "gsap/ScrollTrigger";
import SplitText from "gsap/SplitText";
import ScrollSmoother from "gsap/ScrollSmoother";
gsap.registerPlugin(ScrollSmoother, ScrollTrigger, SplitText);

import Swiper, { Autoplay, Navigation, Parallax, Scrollbar } from "swiper";

/* -------------------------------------------------------------------------- */
/* ------------------------ THEME : GLOBAL VARIABLES ------------------------ */

// Default : Smooth scrolling
let scrollSmooth = false;
// GSAP : Activation du scrollSmoother (avec ScrollSmoother)
scrollSmooth = ScrollSmoother.create({
	wrapper: "#page-wrapper",
	content: "#page-container",
	smooth: 1,
	smoothTouch: false,
	effects: true,
	normalizeScroll: false,
	ignoreMobileResize: true,
});

/* -------------------------------------------------------------------------- */
/* ------------------------- THEME : GLOBAL EVENTS -------------------------- */

// DOCUMENT READY :
document.addEventListener("DOMContentLoaded", () => {
	// remove 'no-js' body class
	document.body.classList.remove("no-js");
	gsapPreloader();
	scrollDetection(160);
	menuBurger();
	menuDropdown();
	bannerToClose();
	bannerToMarquee();
	popinInit();
	toggleInit();
	allSwiperInit();
	// sessionStorage.setItem("visited", true);
});

// DOCUMENT RESIZED (avec ScrollTrigger)
ScrollTrigger.addEventListener("refreshInit", () => {
	gsapScrollSmootherRefresh();
	bannerToMarquee();
});

/* -------------------------------------------------------------------------- */
/* ----------------------- THEME : GLOBAL FUNCTIONS ------------------------- */

// Global : Activation/désactivation du scroll
function scrollEnabled(_bool) {
	if (scrollSmooth) {
		if (_bool == false) {
			// Bloquer le scroll
			scrollSmooth.paused(true);
			document.documentElement.style.overflowY = "hidden";
		}
		if (_bool == true) {
			// Activer le scroll
			scrollSmooth.paused(false);
			document.documentElement.style.overflowY = "auto";
		}
	} else {
		if (_bool == false) {
			// Bloquer le scroll
			document.documentElement.style.overflowY = "hidden";
		}
		if (_bool == true) {
			// Activer le scroll
			document.documentElement.style.overflowY = "auto";
		}
	}
}

// Global : Détection du scroll sur le body
function scrollDetection(_scrollOffset = 0) {
	let position = window.pageYOffset;

	if (position > _scrollOffset) {
		document.body.classList.add("page-scrolled");
	} else {
		document.body.classList.remove("page-scrolled");
	}

	document.addEventListener("scroll", () => {
		// detect scroll direction
		let scroll = window.pageYOffset;
		if (scroll > position) {
			// if scroll to bottom
			if (scroll < _scrollOffset) {
				document.body.classList.remove("page-scrolled");
				document.body.classList.remove("page-scrolling");
			} else {
				document.body.classList.add("page-scrolling");
				document.body.classList.add("page-scrolled");
			}
		}
		// if scroll to top
		else {
			document.body.classList.remove("page-scrolling");
			if (scroll < _scrollOffset) {
				document.body.classList.remove("page-scrolled");
			}
		}
		// if scroll max reached
		if (scroll + window.innerHeight >= document.documentElement.scrollHeight) {
			document.body.classList.add("page-scroll-completed");
		} else {
			document.body.classList.remove("page-scroll-completed");
		}
		position = scroll;
	});
}

// Menu Burger : Comportement au clic
function menuBurger() {
	const headerBurgerButton = document.querySelector("#page-header-burger");
	const headerBurgerArea = document.querySelector("#page-header");

	if (headerBurgerButton) {
		headerBurgerButton.addEventListener("click", () => {
			if (document.body.classList.contains("page-with-fullscreenmenu")) {
				scrollEnabled(true);
				document.body.classList.remove("page-with-fullscreenmenu");
			} else {
				scrollEnabled(false);
				document.body.classList.add("page-with-fullscreenmenu");
			}
		});

		document.addEventListener("mouseup", (event) => {
			if (
				document.body.classList.contains("page-with-fullscreenmenu") &&
				!headerBurgerButton.contains(event.target) &&
				headerBurgerButton !== event.target &&
				!headerBurgerArea.contains(event.target) &&
				headerBurgerArea !== event.target
			) {
				scrollEnabled(true);
				document.body.classList.remove("page-with-fullscreenmenu");
			}
		});
	}
}

// Menu Dropdown : Comportement au clic
function menuDropdown() {
	const menuItemLinks = document.querySelectorAll(
		'.menu .menu__item .menu__link[href="#"]'
	);

	menuItemLinks.forEach((item) => {
		item.closest(".menu__item").classList.add("menu__item--parent");
		item.addEventListener("click", (event) => {
			event.preventDefault();
			item.closest(".menu__item").classList.toggle("menu__item--active");
		});
	});

	document.addEventListener("mouseup", (event) => {
		const activeMenuItems = document.querySelectorAll(
			".menu .menu__item.menu__item--active"
		);

		activeMenuItems.forEach((activeItem) => {
			if (
				!activeItem.isEqualNode(event.target) &&
				!activeItem.contains(event.target)
			) {
				activeItem.classList.remove("menu__item--active");
			}
		});
	});
}

// Bannière : Fermeture
function bannerToClose() {
	const pageBanner = document.querySelector("#page-banner");
	const pageBannerClose = document.querySelector("#page-banner-close");

	if (pageBanner) {
		// bouton de fermeture
		pageBannerClose.addEventListener("click", () => {
			document.body.classList.remove("page-with-banner");
		});
	}
}

// Bannière : Activation/désactivation du défilement horizontal
function bannerToMarquee() {
	const pageBanner = document.querySelector("#page-banner");

	if (pageBanner) {
		const bannerwrapperWidth = pageBanner.offsetWidth;
		const bannerTextWidth =
			pageBanner.querySelector(".banner__text").offsetWidth;
		if (bannerwrapperWidth > bannerTextWidth + 60) {
			pageBanner.classList.remove("page__banner--scrolling");
		} else {
			pageBanner.classList.add("page__banner--scrolling");
		}
	}
}

// Data-popin : Action au clic
function popinInit() {
	const popins = document.querySelectorAll("[data-popin]");

	popins.forEach((popin) => {
		popin.addEventListener("click", (event) => {
			// event.preventDefault();

			// ouvrir/fermer la popin
			const thispopinName = popin.dataset.popin;
			if (thispopinName) {
				const thispopinEl = document.querySelector(
					`.page__popin#${thispopinName}`
				);
				thispopinEl.classList.toggle("page__popin--open");
			}

			// mettre les vidéos des popins en pause
			const htmlVideoFrompopin =
				document.querySelectorAll(".page__popin video");
			if (htmlVideoFrompopin.length > 0) {
				htmlVideoFrompopin.forEach((video) => {
					video.pause();
				});
			}
		});
	});

	document.addEventListener("mouseup", (event) => {
		// si une popin est ouverte
		if (
			document.querySelectorAll(".page__popin.page__popin--open").length > 0
		) {
			// clic en dehors de la zone
			if (
				!document
					.querySelector(".page__popin .popin__wrapper")
					.contains(event.target) &&
				document.querySelector(".page__popin .popin__wrapper") !== event.target
			) {
				// fermer la popin
				document.querySelectorAll(".page__popin").forEach((popin) => {
					popin.classList.remove("page__popin--open");
				});

				// mettre les vidéos des popins en pause
				const htmlVideoFrompopin =
					document.querySelectorAll(".page__popin video");
				if (htmlVideoFrompopin.length > 0) {
					htmlVideoFrompopin.forEach((popinVideo) => {
						popinVideo.pause();
					});
				}
			}
		}
	});
}

// Data-toggle : Action au clic
function toggleInit() {
	const toggleListeners = document.querySelectorAll("[data-toggle]");

	toggleListeners.forEach((toggleElement) => {
		toggleElement.addEventListener("click", (event) => {
			event.stopPropagation();
			// récupérer la cible
			let toggleTarget = toggleElement.dataset.toggle;
			if (toggleTarget) {
				let toggleTargetEl = document.querySelector(toggleTarget);
				if (toggleTargetEl) {
					// Retirer ou ajouter la classe "--active" à la cible selon son état actuel
					toggleTargetEl.classList.toggle("--active");
				}
			}
		});
	});

	// Ajouter un écouteur d'événement au document pour détecter les clics en dehors des éléments ciblés
	document.addEventListener("click", (event) => {
		const toggleTargets = document.querySelectorAll("[data-toggle]");
		toggleTargets.forEach((toggleElement) => {
			let toggleTarget = toggleElement.dataset.toggle;
			if (toggleTarget) {
				let toggleTargetEl = document.querySelector(toggleTarget);
				if (toggleTargetEl && !toggleTargetEl.contains(event.target)) {
					// Retirer la classe "--active" si le clic est en dehors de la cible
					toggleTargetEl.classList.remove("--active");
				}
			}
		});
	});
}

// Swiper : Activation des sliders
function allSwiperInit() {
	if (
		document.querySelectorAll(
			".section-archive-related-news .swiper .swiper-slide"
		).length > 0
	) {
		const swiperRelatedNews = new Swiper(
			".section-archive-related-news .swiper",
			{
				// Core parameters
				slidesPerView: "auto",
				speed: 1200,
				resizeObserver: true,
				// Modules
				modules: [Autoplay, Scrollbar],
				// Modules parameters
				autoplay: {
					delay: 3600,
					disableOnInteraction: true,
				},
				scrollbar: {
					el: ".section-archive-related-news .swiper-scrollbar",
					draggable: true,
				},
			}
		);
	}
}

/* --------------------------------- (GSAP) --------------------------------- */

// GSAP : Rafraîchissement du ScrollSmoother (avec ScrollSmoother)
function gsapScrollSmootherRefresh() {
	if (scrollSmooth) {
		// Désactiver sur Élémentor
		if (document.querySelector("body.elementor-editor-active")) {
			scrollSmooth.kill();
		} else {
			scrollSmooth.refresh();
		}
	}
}

// GSAP : Scroll vers une ancre (avec ScrollSmoother)
function gsapScrollTo(_scrollOffset = 0) {
	// au chargement
	let hashInUrl = window.location.hash;
	if (hashInUrl) {
		scrollSmooth.scrollTo(hashInUrl, true, `top ${_scrollOffset}px`);
	}

	// avec un [href="#..."]
	const scrollToAnchor = document.querySelectorAll('a[href^="#"]');
	scrollToAnchor.forEach((link) => {
		link.addEventListener("click", (event) => {
			event.preventDefault();
			let anchorHref = link.getAttribute("href");
			scrollSmooth.scrollTo(anchorHref, true, `top ${_scrollOffset}px`);
		});
	});

	// avec un [data-scrollto]
	const scrollToData = document.querySelectorAll("[data-scrollto]");
	scrollToData.forEach((data) => {
		data.addEventListener("click", () => {
			let anchorData = data.getAttribute("data-scrollto");
			if (anchorData == "auto") {
				anchorData = window.innerHeight + window.scrollY;
			}
			scrollSmooth.scrollTo(anchorData, true, `top ${_scrollOffset}px`);
		});
	});
}

// GSAP : Découpage des textes (avec SplitText)
function gsapSplitText() {
	const textsToAnimated = document.querySelectorAll([
		// global
		'[data-animation="reveal-text"]',
		".page__main .elementor-heading-title",
	]);

	textsToAnimated.forEach((_thisText) => {
		new SplitText(_thisText, {
			tag: "span",
			type: "lines, words, chars",
			linesClass: "line",
			wordsClass: "word",
			charsClass: "char",
		});
	});
}

// GSAP : Animations au scroll (avec ScrollTrigger)
function gsapAnimations() {
	// Élements (dans header) intervertissant la classe --animated
	const elementsInHeaderToAnimated = document.querySelectorAll([
		// global
		"header [data-animation]",
	]);
	elementsInHeaderToAnimated.forEach((_this) => {
		const delay = _this.getAttribute("data-animation-delay")
			? parseInt(_this.getAttribute("data-animation-delay"), 10)
			: 0;
		ScrollTrigger.create({
			trigger: _this,
			start: "top 100%",
			end: "bottom 0%",
			onEnter: () => {
				setTimeout(() => {
					_this.classList.add("--animated");
				}, delay);
			},
			onLeaveBack: () => {
				_this.classList.remove("--animated");
			},
			// markers: true,
		});
	});

	// Élements (hors header) intervertissant la classe --animated
	const elementsOutHeaderToAnimatedLater = document.querySelectorAll([
		// global
		"[data-animation]:not(header [data-animation])",
		// elementor
		".page__main .elementor-heading-title",
		".page__main .elementor-element > .elementor-element > .elementor-element:not([data-animation])",
	]);
	setTimeout(() => {
		elementsOutHeaderToAnimatedLater.forEach((_this) => {
			const delay = _this.getAttribute("data-animation-delay")
				? parseInt(_this.getAttribute("data-animation-delay"), 10)
				: 0;
			ScrollTrigger.create({
				trigger: _this,
				start: "top 100%",
				end: "bottom 0%",
				onEnter: () => {
					setTimeout(() => {
						_this.classList.add("--animated");
					}, delay);
				},
				onLeaveBack: () => {
					_this.classList.remove("--animated");
				},
				// markers: true,
			});
		});
	}, 300);

	// Élements décomptés au scroll
	const elementsToCounter = document.querySelectorAll(
		'[data-animation="counter"]'
	);
	elementsToCounter.forEach((_this) => {
		ScrollTrigger.create({
			trigger: _this,
			start: "top 100%",
			end: "bottom 0%",
			// markers: true,
			onEnter: () => {
				gsap.from(_this, {
					duration: 1.5,
					textContent: 0,
					snap: { textContent: 1 },
					stagger: {
						each: 1.0,
						onUpdate: function () {
							this.targets()[0].innerHTML = Math.ceil(
								this.targets()[0].textContent
							)
								// conserver les "."
								.toString()
								.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
								// conserver les espaces
								.toString()
								.replace(/\B(?=(\d{3})+(?!\d))/g, "&nbsp;");
						},
					},
				});
			},
		});
	});

	// Élements collés au scroll
	const elementsToSticky = document.querySelector("[data-sticky]");
	if (elementsToSticky) {
		ScrollTrigger.matchMedia({
			// desktop
			"(min-width: 1024px)": () => {
				ScrollTrigger.create({
					trigger: elementsToSticky.firstElementChild,
					start: "center center",
					end: () =>
						`${
							elementsToSticky.offsetHeight -
							elementsToSticky.firstElementChild.offsetHeight
						}`,
					pin: true,
					pinSpacing: false,
					invalidateOnRefresh: true,
					// markers: true,
				});
			},
		});
	}
}

// Actions avant le preLoader d'accueil
function beforePreloader() {
	scrollEnabled(false);
	gsapSplitText();
}

// Actions après le preLoader d'accueil
function afterPreloader() {
	scrollEnabled(true);
	gsapAnimations();
	gsapScrollTo();
}

// GSAP : Loader d'accueil
function gsapPreloader() {
	// Chargement des fonctions GSAP préalables
	beforePreloader();

	// Lancement de l'animation de chargement
	let loaderTimeline = gsap.timeline();
	loaderTimeline
		// animation
		.to("#page-preloader .preloader__wrapper", {
			delay: 0.3,
			duration: 0.6,
			ease: "power2.out",
			opacity: 0,
		})
		.set("#page-preloader", {
			visibility: "hidden",
		});

	// Functions succédentes
	loaderTimeline.add(afterPreloader, loaderTimeline.duration() - 0.3);
}
